<template>
  <div
    class="d-flex flex-wrap"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <span class="col-10 text-left">
      <slot></slot>
    </span>
    <div class="" v-if="!hover">
      <span
        class="icon-circle-right"
        v-show="opcionVer"
        style="color: #546e7a"
      ></span>
    </div>
    <div class="" v-else @click="$emit('ver')">
      <span
        class="icon-eye"
        v-show="opcionVer"
        style="color: #c9caff; position: absolute"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ver-registro",
  data() {
    return {
      hover: false,
    };
  },
  beforeMount() {},
  props: ["row", "opcionVer"],
  emits: ["ver"],
};
</script>

<style lang="scss" scoped>
</style>